<div class="contents-area">
  <div class="element-column">
    <div class="column-list">
      <label class="list-input-title">宅配業態</label>
      <div class="list-input-content">
        <app-radio-label name="rbtn_Weekly" #DeliveryDiv label="ウィークリー" id="rbtn_Weekly" [subid]="'rbtn_Weekly'"
          value="1" [tabindex]="0" [forcedEnabledMode]="'true'" [(ngModel)]="kymw7200Model.deliveryDiv">
        </app-radio-label>
        <app-radio-label name="rbtn_Daily" #DeliveryDiv label="デイリー" id="rbtn_Daily" [subid]="'rbtn_Daily'" value="2"
          [tabindex]="0" [forcedEnabledMode]="'true'" [(ngModel)]="kymw7200Model.deliveryDiv">
        </app-radio-label>
      </div>

      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">注文コード</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw7200Model.orderNum" [maxlength]="6" plessInputTextSub [restrict]="'[0-9]'" style="width: 70px;">
            </div>
            <label class="list-input-title">運営企画区分</label>
            <div class="list-input-content">
              <app-code-combo-box [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [codeDiv]="'ctp206'"
                #cmb_PlanningManagementDiv id="cmb_PlanningManagementDiv"
                (change)="cmb_planningManagementDiv_CHANGEHandler()" [tabindex]="0"
                [(ngModel)]="kymw7200Model.planningManagementDiv" style="width: 200px;">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">商品名</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw7200Model.goodsName" [maxlength]="15" style="width: 17rem;" plessInputTextSub [restrict]="'[ -￮]'">
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">受注企画回</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw7200Model.orderCatalog" [maxlength]="8" plessInputTextSub [restrict]="'[0-9]'" style="width: 90px;">
            </div>
            <label class="list-input-title">運営企画詳細区分</label>
            <div class="list-input-content">
              <app-code-combo-box [codeDiv]="kymw7200Model.setCodeDiv" [conReserveNum1]="kymw7200Model.setReserveNum1"
                [labelField]="'codeValueName'" [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true"
                #cmb_PlanningManagementDetailDiv id="cmb_PlanningManagementDetailDiv"
                [(ngModel)]="kymw7200Model.planningManagementDetailDiv" style="width: 320px;">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">規格名</label>
            <div class="list-input-content">
              <input type="text" [(ngModel)]="kymw7200Model.standardName" [maxlength]="10" style="width: 12rem;" plessInputTextSub [restrict]="'[ -￮]'">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button [tabindex]="0" class="btn-secondary" 
      (click)="eventSearchOperationGoods_CLICKHandler()">検索</button>  

      <!-- 運営商品一覧領域 -->
      <div class="action-area">
        <app-pager [prevDisabled]="kymw7200Model.prevDisabled" [nextDisabled]="kymw7200Model.nextDisabled"
          [totalNum]="kymw7200Model.totalNum" [startNum]="kymw7200Model.startDispNum" [endNum]="kymw7200Model.endDispNum"
          (prevHandler)="eventPrev_CLICKHandler()" (nextHandler)="eventNext_CLICKHandler()">
        </app-pager>
      </div>
      <wj-flex-grid #dtg_OperationGoodsList [itemsSource]="kymw7200Model.operationGoodsListData" class="space-bottom"
        [tabindex]="0" id="dtg_OperationGoodsList" [headersVisibility]="'Column'" [allowSorting]="false"
        verticalScrollPolicy="'on'" horizontalScrollPolicy="'off'" [autoRowHeights]="true" forcedEnabledMode="true"
        [selectionMode]="'Row'" [allowDragging]="'None'" (pasting)="onPasting($event)">
        <wj-flex-grid-column [minWidth]="5" [header]="' '" [visible]="true" [binding]="'targetFlg'" [width]="40"
          [isReadOnly]="true">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">
              <input type="checkbox" id="TargetFlg_{{cell.row.index}}" [(ngModel)]="cell.item.targetFlg" [tabindex]="-1"
                (mouseup)="$event.stopPropagation()" (click)="checkBoxEventOperationGoodsMark_CLICKHandler($event);" />
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ステータス'" [width]="80" [binding]="'operationGoodsStatusName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'宅配業態'" [width]="80" [binding]="'deliveryDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'注文コード'" [width]="90" [binding]="'orderNum'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'利用生協'" [width]="150" [binding]="'coopCodeList'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'運営企画区分'" [width]="160" [binding]="'planningManagementDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'運営企画詳細区分'" [width]="270" [binding]="'planningManagementDetailDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'受注受付開始企画回'" [width]="150" [binding]="'orderReceptionStartCatalog'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'受注受付終了企画回'" [width]="150" [binding]="'orderReceptionEndCatalog'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'積立増資パターン'" [width]="130" [binding]="'depositCapitalIncreasePatternName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'積立増資回数'" [width]="110" [binding]="'depositCapitalIncreaseCount'" [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単価'" [width]="90" [binding]="'unitPrice'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div>{{cell.item.unitPrice | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'帳票チラシコード'" [width]="120" [binding]="'formFlyerCode'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ポイント数'" [width]="80" [binding]="'pointNumber'" [isReadOnly]="true" [align]="'right'">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'休止グループコード'" [width]="130" [binding]="'pauseGroupCode'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'PD区分'" [width]="180" [binding]="'pdDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'配達リード区分'" [width]="110" [binding]="'deliveryLeadDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="230" [binding]="'goodsName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品名カナ'" [width]="150" [binding]="'goodsNameKana'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="170" [binding]="'standardName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'規格名カナ'" [width]="110" [binding]="'standardNameKana'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'計上部門'" [width]="130" [binding]="'appropriatingClassName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'消費税区分'" [width]="90" [binding]="'consumeTaxDivName'" [isReadOnly]="true">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'消費税率'" [width]="80" [binding]="'consumeTaxRate'" [isReadOnly]="true" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.consumeTaxRate | comma | suffix:'%'}}</div>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button (click)="eventDeleteOperationGoods_CLICKHandler(null)" class="btn-tartiary warning" forcedEnabledMode="none"
    [tabindex]="0" id="btn_Delete" #btn_Delete>削除</button>
  <button (click)="eventKYMW7201_CLICKHandler()" class="btn-primary" forcedEnabledMode="none"
    [tabindex]="0" id="btn_NewAdd" #btn_NewAdd>新規追加</button>
</footer>
